import { Box, Link } from 'theme-ui';
import { Flex } from 'lib/ui';
import facebookRoundLogo from 'images/facebook.png';
import twitterRoundLogo from 'images/twitter.png';

const StyledItem = ({ children, ...props }) => {
  return (
    <li
      sx={{
        display: 'block',
        textAlign: 'left',
        padding: ['5px 0', null, null, '5px 0.6rem'],
      }}
      {...props}
    >
      {children}
    </li>
  );
};

const StyledLink = ({ href, children, ...props }) => {
  return (
    <Link
      href={href}
      color="#a09e99"
      sx={{
        fontSize: 'inherit',
        textDecoration: 'none',
        ':hover': {
          color: '#fff',
          textDecoration: 'none'
        },
      }}
      {...props}
    >
      {children}
    </Link>
  );
};


const BottomNav = ({ width, className }: any) => {
  return (
    <Flex
      className={className}
      alignItems="center"
      backgroundColor="#32312c"
      color="#a09e99"
    >
      <Flex
        alignItems="center"
        backgroundColor="#32312c"
        sx={{
          width,
          margin: '0 auto',
        }}
      >
        <Flex
          alignItems="center"
          sx={{
            margin: '0 auto',
            width: '100%',
            '::before': {
              display: 'table',
              content: '""'
            }
          }}
        >
          <Box>
            © 2025 Lunaverse Software
          </Box>
          <Flex
            sx={{
              marginLeft: 'auto',
              display: ['none', null, null, 'flex']
            }}
          >
            <nav>
              <ul
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  left: 0,
                  marginBottom: '22px',
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                }}
              >
                <StyledItem><StyledLink href="http://slotted.tumblr.com" title="Visit the Slotted blog">Blog</StyledLink></StyledItem>
                <StyledItem><StyledLink href="/home/about" data-original-title="Learn about us">About Us</StyledLink></StyledItem>
                <StyledItem><StyledLink href="/home/terms" data-original-title="View our terms of use">Terms of Use</StyledLink></StyledItem>
                <StyledItem><StyledLink href="/home/privacy" data-original-title="View our privacy policy">Privacy</StyledLink></StyledItem>
                <StyledItem>
                  <Link
                    target="blank"
                    title="Become a Slotted fan on Facebook"
                    href="https://www.facebook.com/slottedco"
                  >
                    <img
                      sx={{
                        verticalAlign: 'middle'
                      }}
                      title="Slotted on Facebook" width="38" height="37"
                      src={facebookRoundLogo}
                    />
                  </Link>
                </StyledItem>
                <StyledItem>
                  <Link
                    target="blank"
                    title="Follow slotted on Twitter"
                    href="https://twitter.com/slottedco"
                  >
                    <img
                      sx={{
                        verticalAlign: 'middle'
                      }}
                      title="Slotted on Twitter" width="38" height="37"
                      src={twitterRoundLogo}
                    />
                  </Link>
                </StyledItem>
              </ul>
            </nav>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BottomNav;
